export interface UpdateLog {
  id: string;
  version: string;
  date: string;
  title: string;
  description: string;
  type: "feature" | "fix" | "optimize" | "content";
  badge: string;
}

export const updateLogs: UpdateLog[] = [
  {
    id: "1",
    version: "v2.4.0",
    date: "2026-06-08",
    title: "新增趣味换脸模板",
    description: "新增 6 套三峡主题换脸模板，包括屈原、白帝城、神女峰等历史人物造型。",
    type: "feature",
    badge: "新功能",
  },
  {
    id: "2",
    version: "v2.3.2",
    date: "2026-06-05",
    title: "场景音频生成优化",
    description: "优化 AI 语音生成引擎，讲解音频生成速度提升 40%，音质更自然。",
    type: "optimize",
    badge: "优化",
  },
  {
    id: "3",
    version: "v2.3.1",
    date: "2026-06-02",
    title: "设备配对流程简化",
    description: "批量配对支持二维码批量生成，一键绑定整船游客，减少人工操作时间。",
    type: "feature",
    badge: "新功能",
  },
  {
    id: "4",
    version: "v2.3.0",
    date: "2026-05-28",
    title: "新增葛洲坝场景知识库",
    description: "新增葛洲坝 12 条知识卡片、3 条讲解音频，覆盖工程历史与运行原理。",
    type: "content",
    badge: "内容更新",
  },
  {
    id: "5",
    version: "v2.2.5",
    date: "2026-05-20",
    title: "修复设备低电量预警延迟",
    description: "修复部分设备电量低于 20% 时预警推送延迟的问题，预警响应时间优化至 30 秒内。",
    type: "fix",
    badge: "Bug 修复",
  },
  {
    id: "6",
    version: "v2.2.4",
    date: "2026-05-15",
    title: "新增南津关景点",
    description: "新增南津关景点触发点，包含 9 条知识卡片、2 条讲解音频及 5 张实景图片。",
    type: "content",
    badge: "内容更新",
  },
];

export interface QuickAction {
  icon: string;
  title: string;
  desc: string;
  color: string;
  bg: string;
  path: string;
}

export const quickActions: QuickAction[] = [
  {
    icon: "ri-link",
    title: "批量预配对",
    desc: "为下一船次眼镜提前生成配对码",
    color: "text-teal-600",
    bg: "bg-teal-50",
    path: "/devices",
  },
  {
    icon: "ri-map-pin-add-line",
    title: "新增景点",
    desc: "在航线上添加新讲解触发点",
    color: "text-amber-600",
    bg: "bg-amber-50",
    path: "/scenes",
  },
  {
    icon: "ri-image-add-line",
    title: "上传换脸模板",
    desc: "上传新主题换脸模板供游客使用",
    color: "text-rose-600",
    bg: "bg-rose-50",
    path: "/faceswap",
  },
  {
    icon: "ri-file-download-line",
    title: "导出今日报表",
    desc: "生成今日运营数据 Excel 报表",
    color: "text-emerald-600",
    bg: "bg-emerald-50",
    path: "/analytics",
  },
];